import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from "vue";
import { useStore } from "@/stores";
import { Message } from "element-ui";
import { Request } from "@/utils/Request";
import { API_BIS_DATA_DOWNLOAD, API_BIS_ASSET } from "@/configs/Apis";


export default /*#__PURE__*/_defineComponent({
  __name: 'PatentDrawing',
  props: {
  patentId: { type: [String, Number], required: true },
  active: { type: Boolean, default: true },
},
  setup(__props) {

const props = __props;



const store = useStore();
const projectId = computed(() => (store.state as any).project.info?.id ?? 0);

const http = new Request();

const loading = ref(false);
const errorMsg = ref("");
const loaded = ref(false);
const imagePaths = ref<string[]>([]);

const fetchAssets = async () => {
  if (!props.patentId || !projectId.value || loaded.value) return;
  loading.value = true;
  errorMsg.value = "";
  try {
    const url = API_BIS_DATA_DOWNLOAD.replace("{projectId}", String(projectId.value));
    const res: any = await http.request(url, { patentId: props.patentId }, "POST");

    const data = res?.data ?? res ?? {};
    imagePaths.value = Array.isArray(data.images) ? data.images : [];

    if (Array.isArray(data.errors) && data.errors.length > 0) {
      console.warn("[PatentDrawingTab] 部分附件下载失败:", data.errors);
      Message.warning("部分附图下载失败");
    }
    loaded.value = true;
  } catch (e: any) {
    console.error("[PatentDrawingTab] 附件下载失败:", e);
    errorMsg.value = "附图加载失败";
    Message.error("附图加载失败");
  } finally {
    loading.value = false;
  }
};

// 切到 tab 时触发
watch(
  () => props.active,
  (isActive) => {
    if (isActive) fetchAssets();
  },
  { immediate: true }
);

// 换专利时重置已加载状态并重新下载
watch(
  () => props.patentId,
  () => {
    loaded.value = false;
    imagePaths.value = [];
    errorMsg.value = "";
    if (props.active) fetchAssets();
  }
);

const buildAssetUrl = (path: string): string => {
  if (!path) return "";
  const cleanPath = String(path).trim().replace(/^\/+/, "");
  if (!cleanPath) return "";
  const url = API_BIS_ASSET.replace("{projectId}", String(projectId.value));
  return `/api${url}?patentId=${props.patentId}&path=${encodeURIComponent(cleanPath)}`;
};

const allImageUrls = computed<string[]>(() => imagePaths.value.map(buildAssetUrl));

// 后端 WipsAssetService.resolveImageUrls 顺序：摘要附图(abstractInfoPicture) → drawData.reptDraw → indvDrawData.indvDrawList
// 对应：images[0] = 摘要附图，images[1] = 代表附图，images[2+] = 单张附图
const abstractPictureUrl = computed<string>(() => allImageUrls.value[0] || "");
const repDrawUrls = computed<string[]>(() =>
  allImageUrls.value.length > 1 ? [allImageUrls.value[1]] : []
);
const indvDrawUrls = computed<string[]>(() =>
  allImageUrls.value.length > 2 ? allImageUrls.value.slice(2) : []
);

const hasAnyDrawing = computed(() => allImageUrls.value.length > 0);

return { __sfc: true,props, store, projectId, http, loading, errorMsg, loaded, imagePaths, fetchAssets, buildAssetUrl, allImageUrls, abstractPictureUrl, repDrawUrls, indvDrawUrls, hasAnyDrawing }
}

})